import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import moment from "moment";

import Page from "@/components/Page";
import Loading from "@/components/Loading";
import Breadcrumbs from "@/components/Breadcrumbs";
import MainActions from "@/components/MainActions";
import ScoutReportsContainer from "@/components/ScoutReportsContainer";

import {ScoutReportAPI} from "@/api/scout_report";

import AddIcon from "@mui/icons-material/Add";

import "./index.scss";

const fieldDateFormat = "YYYY-MM-DD";

const defaultFiltersData = {
	toDate: moment().endOf("month").format(fieldDateFormat),
};

function ScoutingReportsPage() {
	const navigate = useNavigate();

	const [loading, setLoading] = useState(false);
	const [reports, setReports] = useState([]);
	const [filtersData, setFiltersData] = useState(
		JSON.parse(sessionStorage.getItem("scouting_reports_filters")) ||
			defaultFiltersData,
	);
	const [search, setSearch] = useState("");

	useEffect(() => {
		if (filtersData) {
			sessionStorage.setItem(
				"scouting_reports_filters",
				JSON.stringify(filtersData),
			);
		}
	}, [filtersData]);

	const filters = [
		{
			key: "search",
			label: "Giocatore",
			value: search || "",
			setValue: (value) => {
				sessionStorage.setItem(
					"scouting_database_filters",
					JSON.stringify({search: value}),
				);
				setSearch(value);
			},
		},
		{
			key: "fromDate",
			type: "date",
			label: "Da",
			clearable: true,
			value: filtersData?.fromDate
				? moment(filtersData?.fromDate).format(fieldDateFormat)
				: null,
			setValue: (e) => {
				setFiltersData({
					...filtersData,
					fromDate: e ? moment(e).format(fieldDateFormat) : "",
				});
			},
		},
		{
			key: "toDate",
			type: "date",
			label: "A",
			clearable: false,
			value: moment(filtersData?.toDate).format(fieldDateFormat),
			setValue: (e) => {
				if (e) {
					setFiltersData({
						...filtersData,
						toDate: moment(e).format(fieldDateFormat),
					});
				}
			},
		},
	];

	const getReports = async () => {
		setLoading(true);
		try {
			const response = await ScoutReportAPI.list(filtersData);
			setReports(response);
		} catch (error) {
			console.log(error);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		getReports();
	}, [filtersData]);

	const mainActions = [
		{
			icon: <AddIcon />,
			onClick: () => navigate("/scouting/reports/new"),
		},
	];

	const filteredReports = search
		? reports?.filter(
				(r) =>
					r.player.firstName.toLowerCase().indexOf(search?.toLowerCase()) !==
						-1 ||
					r.player.lastName.toLowerCase().indexOf(search?.toLowerCase()) !== -1,
			)
		: reports;

	return (
		<Page className="scout-reports-container">
			<Loading visible={loading} />
			<Breadcrumbs actions={<MainActions actions={mainActions} />} />
			<ScoutReportsContainer
				reports={filteredReports}
				filters={filters}
				breadcrumbs
			/>
		</Page>
	);
}

export default ScoutingReportsPage;
